/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconAlignBoxRightTop = createReactComponent(
  "align-box-right-top",
  "IconAlignBoxRightTop",
  [
    [
      "path",
      {
        d: "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z",
        key: "svg-0"
      }
    ],
    ["path", { d: "M15 13h2", key: "svg-1" }],
    ["path", { d: "M11 10h6", key: "svg-2" }],
    ["path", { d: "M13 7h4", key: "svg-3" }]
  ]
);

export { IconAlignBoxRightTop as default };
//# sourceMappingURL=IconAlignBoxRightTop.js.map
